import { Brand } from "@/models/Brands.model";
import { create } from "zustand";

type BrandsState = {
  brands: Brand[] | null;
  setBrands: (brands: Brand[]) => void;
};

export const useBrandsStore = create<BrandsState>(
  (set: (partial: Partial<BrandsState>) => void) => ({
    brands: null,
    setBrands: (newBrands) =>
      set({
        brands: newBrands,
      }),
  })
);
